import {IResponse} from '../../common/model/Core.model'
import {environment} from '../../util/Environment'
import {apiSlice} from '../store/Api'
import {
  IClientCreateRequestDto,
  IClientUpdateRequestDto,
  IClientDto,
  IClientSearchRequestDto,
} from './Client.model'
export const clientApi = apiSlice.injectEndpoints({
  endpoints(builder) {
    return {
      clientSearch: builder.mutation<IResponse, IClientSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.client}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      clientLoadMore: builder.mutation<IResponse, IClientSearchRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.client}/search`,
            method: 'POST',
            body,
          }
        },
      }),
      clientGetById: builder.mutation<IClientDto, {id: string; details?: boolean; fields?: string}>({
        query(parameters) {
          const queryParams =
            !parameters.details && parameters.fields ? `?fields=${parameters.fields}` : ''
          return {
            url: `${environment.apiUrl.client}/${parameters.id}` + queryParams,
            method: 'GET',
          }
        },
      }),
      clientCreate: builder.mutation<IClientDto, IClientCreateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.client}`,
            method: 'POST',
            body,
          }
        },
      }),
      clientUpdateById: builder.mutation<IClientDto, IClientUpdateRequestDto>({
        query(body) {
          return {
            url: `${environment.apiUrl.client}/${body.id}`,
            method: 'PATCH',
            body,
          }
        },
      }),
      clientDeleteById: builder.mutation<void, string>({
        query(id) {
          return {
            url: `${environment.apiUrl.client}/${id}`,
            method: 'DELETE',
          }
        },
      }),
    }
  },
})

export const {
  useClientSearchMutation,
  useClientLoadMoreMutation,
  useClientCreateMutation,
  useClientUpdateByIdMutation,
  useClientGetByIdMutation,
  useClientDeleteByIdMutation,
} = clientApi
